export const AFFILIATE_PROFILE_GENERAL_ROUTE_NAME = Symbol('admin.affiliates.approved.profile.general');
export const TRANSLATION_GROUP_AFFILIATE_PROFILE_GENERAL = Symbol('admin.affiliates.approved.profile.general');
